import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataStorageService } from '../dataStorage/data-storage.service';

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	constructor(
		private toastr: ToastrService,
		private router: Router,
		private dataStorageService: DataStorageService
	) {}

	createHttpErrorToast(errorMessage: string | any, errorCode: number): void {
		switch (errorCode) {
			case 401:
				this.toastr.error(
					'Veuillez vous connecter.',
					"Erreur d'authentification",
					{
						closeButton: true,
						progressBar: true
					}
				);
				break;
			case 404:
				this.toastr.error(errorMessage, 'Ressource non trouvée', {
					closeButton: true,
					progressBar: true
				});
				break;
			case 409:
				this.toastr.error(errorMessage, 'Conflit', {
					closeButton: true,
					progressBar: true
				});
				break;
			case 500:
				this.toastr.error(errorMessage, 'Erreur', {
					closeButton: true,
					progressBar: true
				});
				break;

			default:
				this.toastr.error(
					"L'opération demandée n'a pas pu aboutir. Message : " +
						errorMessage +
						' (code erreur : ' +
						errorCode +
						')',
					'Une erreur est survenue',
					{
						closeButton: true,
						progressBar: true
					}
				);
				break;
		}
	}

	createSuccessToast(message?: string): void {
		if (message !== null && message !== '') {
			this.toastr.success(
				"L'opération a été réalisé ! \n" + message,
				'Succès',
				{
					closeButton: true,
					progressBar: true
				}
			);
		}
	}

	createSuccessToastWithMessage(message?: string): void {
		if (message !== null && message !== '') {
			this.toastr.success(message, '', {
				closeButton: true,
				progressBar: true
			});
		}
	}

	createInfoToast(message?: string): void {
		if (message !== null && message !== '') {
			this.toastr.info(message, 'Info', {
				closeButton: true,
				progressBar: true
			});
		}
	}

	createWarningToast(message?: string): void {
		if (message !== null && message !== '') {
			this.toastr.warning(message, 'Alerte', {
				closeButton: true,
				progressBar: true
			});
		}
	}

	createErrorToast(message?: string): void {
		if (message !== null && message !== '') {
			this.toastr.error(message, 'Erreur', {
				closeButton: true,
				progressBar: true
			});
		}
	}
}
